import React from 'react'

import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useTranslate } from 'react-admin'

const useStyles = makeStyles({
  messageAlone: {
    marginTop: '36px',
    marginBottom: '36px',
  },
})

export const CreditLineEmpty = () => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <Box textAlign="center" m={1}>
      <Typography paragraph className={classes.messageAlone}>
        {translate('resources.creditLine.empty')}
      </Typography>
    </Box>
  )
}
